import { h } from 'preact';
import style from './style';
import phone from '../../assets/images/phone.png';
import marker from '../../assets/images/map-marker.png';

const Footer = () => (
	<footer class={style.footer}>
		<div class="content">
			<div class={`${style.section} col-12-sm`}>
				<div class="col-4 col-12-sm center">
					<div class={`${style.contactus} cl-12-sm`}>
						<div class="col-12-sm">
							<img src={phone} />
							<span class={style.header}>contact us</span>
							<p>hello@fhird.com</p>
							<p>+46 705 62 77 40</p>
						</div>
					</div>
					<div class={`${style.findus} cl-12-sm`}>
						<div class="col-12-sm">
							<img src={marker} />
							<span class={style.header}>visit us</span>
							<p>Östra hamngatan 17</p>
							<p>411 10 Gothenburg</p>
						</div>
					</div>
					<div class={`${style.findus} cl-12-sm`}>
						<div class="col-12-sm">
							<img src={marker} />
							<span class={style.header}>find us</span>
							<p>Nygaardsgata 36</p>
							<p>1607 Fredrikstad</p>
						</div>
					</div>
				</div>
				<div class={style.copyright}>
					Copyright © {new Date().getFullYear()} Fhird AS. All rights reserved.
				</div>
			</div>
		</div>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js